import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  Row,
  Col,
  Checkbox,
  Modal,
  CheckboxProps,
  message,
  Flex,
} from "antd";
import {
  ArrowRightOutlined,
  DeleteFilled,
  UploadOutlined,
} from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./orderform.css";
import PhotoDetails from "./PhotoDetails";
import StepComponent from "../Sections/Steps";
import GallerySlider from "../Slider/GallerySlider";
import useApiRequest, {
  designCardsData,
  formatDate,
  threeDesignCard,
} from "../../utils/helperFunctions";
import Paypal from "../Pages/MakePayment";
import TermsCon from "../Pages/TermsCon";
// import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
// import { configConsumerProps } from "antd/es/config-provider";
import ConvertedPrice from "../Pages/ConvertedPrice";
const { Item } = Form;

// type ConvertFinalPriceArgs = {
//   sum: number;
//   totalPrice: number;
//   couponInfo?: { discount?: number | null };
//   baseCurrency?: string;
//   country?: string;
//   data?: any;
// };

type CommercialStagingFormProps = {
  unitPrice?: number;
  form_name?: string;
};

interface ImageData {
  image_id: string;
  url: string;
  additional_room_items: string;
  like_in?: any; // Add this line to include the like_in property
  sky_replacement: string;
  template_orientation?: string;
  story_level?: string;
  room_area?: string;
  selected_room_items?: string[];
  additional_services?: any[];
  images?: any[];
  selected_service_items?: any[];
  virtual_staging_text?: string;
}

interface OrderData {
  order_id: string;
  invoice_no: string;
  user_email: string;
  order_status: string;
  final_amount: string;
  images: ImageData[];
  order_name: string;
  additional_services: any[];
  reciever_details: any;
  email: string;
  name: string;
  phone: string;
  furnishing_style: string;
  selected_room_items: string[];
  room_area: any;
  updateEditdata?: any;
}

type AnyObject = Record<string, any>;

const CommercialStagingForm: React.FC<CommercialStagingFormProps> = (props) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    fileList: [] as any[],
    descriptions: [] as string[],
    selectedStyle: "",
    details: [] as any[], // Add this state to track details of each photo
    additionalService: [] as any[],
  });

  const [current, setCurrent] = useState(1);
  const [totalPrice, setTotalPrice] = useState(0);
  const { apiRequest } = useApiRequest();
  const [roomResp, setRoomResp] = useState([]);
  const [asInfo, setAsInfo] = useState([]);
  const [addtionalInfo, setAddtionalInfo] = useState<ImageData[]>([]);
  const [pricePerPhoto, setPricePerPhoto] = useState(8);
  const [paymentModalSwitch, setPaymentModalSwitch] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [orderInfo, setOrderInfo] = useState({
    ID: 0,
    totalPrice: 0.0,
    symbol: "USD",
  });
  const [endpoint, setEndpoint] = useState<string>("");
  const [urlKey, setUrlKey] = useState<any>("");
  const [ujjwal, setujjwal] = useState([]);
  const [agreeTerms, setagreeTerms] = useState(false);
  const [extraAdditionService, setExtraAdditionService] = useState<any>([]);
  const [showDesignCard, setShowDesignCard] = useState<boolean>(false);
  const [addtionalKeyword, setAddtionalKeyword] = useState<string>("");
  const [skyID, setSkyID] = useState<any>([]);
  const [termsModalVisible, setTermsModalVisible] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [orderId, setOrderId] = useState<string>("");
  const [form] = Form.useForm();
  const [orderData, setOrderData] = useState<OrderData | null>(null);
  const [delFunc, setDelFunc] = useState(false);
  const [extraEddition, setExtraAddition] = useState<any>([]);
  const [createResp, setCreateResp] = useState<any>({});
  const [isChange, setIsChange] = useState(false);
  const [couponList, setCouponList] = useState([]);
  const [couponBox, setCouponBox] = useState(false);
  const refVar = useRef<any>();
  const [appliedCoupon, setAppliedCoupon] = useState<string | null>(null);
  const [couponInfo, setCouponInfo] = useState<any>({});
  // const [lastConvertedPrice, setLastConvertedPrice] = useState<any>(null);
  // const [currSym, setCurrSym] = useState("$");
  // const [initCountry, setInitCountry] = useState("United States");

  // settings starts !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  // const makePaymentButtonAmountAutoConverted = false;
  // const debug = false;

  //settings ends !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  const yogendraFunc = (data: any) => {
    setujjwal(data);
  };
  // const [localCurrChanging, setLocalCurrChanging] = useState(0);
  const handleSkychange = (data: any) => {
    setSkyID(data);
  };
  function isChanges() {
    setIsChange(true);
  }
  const getTheKey = () => {
    // Extract the `key` from the URL
    const queryParams = new URLSearchParams(window.location.search);
    const key = queryParams.get("key");
    setUrlKey(key);
  };

  useEffect(() => {
    // Get the current URL
    const currentUrl = window.location.pathname;

    // Extract the last segment of the URL
    const lastSegment = currentUrl.substring(currentUrl.lastIndexOf("/") + 1);
    setEndpoint(lastSegment);
  }, []);

  const getUnitPrice = async () => {
    try {
      const resp = await apiRequest({
        url: "service-price",
        method: "POST",
        showMessage: false,
        payload: { name: urlKey },
        Authentication: true,
      });

      if (resp.status === 200) {
        setPricePerPhoto(resp?.data?.price);
      } else {
        setPricePerPhoto(8);
        message.error("Failed to fetch unit price. Please Reload");
      }
    } catch (errors) {
      console.error("Failed to fetch unit price", errors);
    }
  };

  useEffect(() => {
    if (urlKey?.length === 0) {
      getTheKey();
    } else {
      getUnitPrice();
    }
  }, [urlKey]);

  const [sliderImages, setSliderImages] = useState<string[]>([]);

  const stepConfig = {
    default: [
      { title: "Personal Info" },
      { title: "Select style" },
      { title: "Upload photos" },
      { title: "Photo details" },
      { title: "Add extra" },
    ],
    commercialForms: [
      { title: "Personal Info" },
      { title: "Upload photos" },
      { title: "Payment" },
    ],
  };

  const commercialPaths = [
    "/services/commercial/commercial-staging-form",
    "/edit/services/commercial/commercial-staging-form",
    "/services/commercial/commercial-renovation-form",
    "/edit/services/commercial/commercial-renovation-form",
    "/services/virtual-renovation-form",
    "/edit/services/virtual-renovation-form",
    "/services/virtual-staging-form",
    "/edit/services/virtual-staging-form",
  ];

  const currentPath = window.location.pathname;
  const steps = commercialPaths.includes(currentPath)
    ? stepConfig.default
    : stepConfig.commercialForms;

  useEffect(() => {
    if (commercialPaths.includes(currentPath)) {
      updateStep();
    } else {
      updateLessStep();
    }
  }, [formData, orderData]);

  useEffect(() => {
    const fetchInitialData = async () => {
      await Promise.all([getRoomId()]);
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    calculateTotalPrice();
  }, [formData.fileList]);

  // useEffect(() => {
  //   if(window.location.pathname === "/edit/services/virtual-staging-form"){
  //     getRoomId();
  //   }
  // }, [])

  const getRoomId = async () => {
    try {
      let urlString = "?room_cat=RESIDENTIAL";

      if (
        window.location.pathname ===
          "/services/commercial/commercial-staging-form" ||
        window.location.pathname ===
          "/edit/services/commercial/commercial-staging-form"
      ) {
        urlString = "?room_cat=COMMERCIAL";
      }

      const response = await apiRequest({
        url: `/rooms${urlString}`,
        method: "GET",
        showMessage: false,
      });
      if (response.status === 200) {
        setRoomResp(response.data);
      }
    } catch (error) {
      console.error("Error fetching room options:", error);
    }
  };

  const getASservices = async () => {
    try {
      if (addtionalKeyword.length > 0) {
        const response = await apiRequest({
          url: `/AdditionalServices${addtionalKeyword}`,
          method: "GET",
          showMessage: false,
        });
        if (response.status === 200) {
          setAsInfo(response?.data);
        }
      }
    } catch (error) {
      console.error("Error fetching room options:", error);
    }
  };

  const updateStep = () => {
    if (
      (formData.name && formData.email && formData.phone) ||
      (orderData?.reciever_details?.name &&
        orderData?.reciever_details?.email &&
        orderData?.reciever_details?.phone)
    ) {
      if (formData.selectedStyle) {
        if (formData.fileList.length > 0) {
          if (formData.details.length === formData.fileList.length) {
            setCurrent(4); // Step 5: Add extra
          } else {
            setCurrent(3); // Step 4: Photo details
          }
        } else {
          setCurrent(2); // Step 3: Upload photos
        }
      } else {
        setCurrent(1); // Step 2: Select style
      }
    } else {
      setCurrent(0); // Step 1: Personal Info
    }
  };

  const updateLessStep = () => {
    if (
      (formData.name && formData.email && formData.phone) ||
      (orderData?.reciever_details?.name &&
        orderData?.reciever_details?.email &&
        orderData?.reciever_details?.phone)
    ) {
      if (formData.fileList.length > 0) {
        setCurrent(2); // Step 3: Upload photos
      } else {
        setCurrent(1); // Step 2: Upload photos
      }
    } else {
      setCurrent(0); // Step 1: Personal Info
    }
  };

  const calculateTotalPrice = async () => {
    const newTotalPrice = formData.fileList.length * pricePerPhoto;
    setTotalPrice(newTotalPrice);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    isChanges();
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePhoneChange = (value: string) => {
    isChanges();
    setFormData((prevData) => ({
      ...prevData,
      phone: value,
    }));
  };

  const handleUploadChange = (fileList: any) => {
    isChanges();
    setFormData((prevData) => ({
      ...prevData,
      fileList: fileList.fileList,
    }));
  };
  useEffect(() => {
    if (ujjwal?.length > 0) {
      const newAds: any = getFilteredArray(ujjwal, addtionalInfo);
      setAddtionalInfo(newAds);
    }
  }, [ujjwal]);

  const handleClose = (index: number) => () => {
    setFormData((prevData) => {
      const newFileList = prevData.fileList.slice();
      newFileList.splice(index, 1);
      // const editimg = orderData;

      const newDescriptions = prevData.descriptions.slice();
      newDescriptions.splice(index, 1);

      const newDetails = prevData.details.slice(); // Copy details array
      const removedDetails = newDetails.splice(index, 1); // Remove the object at index

      setAddtionalInfo((prevAddInfo) =>
        prevAddInfo.filter(
          (service: any) =>
            !removedDetails[0]?.services?.some(
              (s: string) => s === service.count
            )
        )
      );

      return {
        ...prevData,
        fileList: newFileList,
        descriptions: newDescriptions,
        details: newDetails, // Use updated newDetails array
      };
    });

    if (orderData) {
      setOrderData((prevData: any) => {
        const newFileList = prevData?.images.slice();
        newFileList.splice(index, 1);

        return {
          ...prevData,
          images: newFileList,
        };
      });
    }
  };

  const handleDescriptionChange =
    (index: number) => (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const { value } = e.target;
      setFormData((prevData) => {
        const newDescriptions = [...prevData.descriptions];
        newDescriptions[index] = value;
        return {
          ...prevData,
          descriptions: newDescriptions,
        };
      });
    };

  const onCheckboxChange: CheckboxProps["onChange"] = (e) => {
    setagreeTerms(e.target.checked);
  };

  const sanitizePayload = (data: AnyObject): AnyObject => {
    const sanitizedObject: AnyObject = {};

    Object.entries(data).forEach(([key, value]) => {
      if (value && typeof value === "object" && !Array.isArray(value)) {
        // Recursively sanitize nested objects
        const sanitizedValue = sanitizePayload(value);
        if (Object.keys(sanitizedValue).length > 0) {
          sanitizedObject[key] = sanitizedValue;
        }
      } else if (Array.isArray(value)) {
        // Filter out empty or invalid elements in arrays
        const sanitizedArray = value
          .map((item) =>
            typeof item === "object" ? sanitizePayload(item) : item
          )
          .filter((item) => item !== null && item !== undefined && item !== "");
        if (sanitizedArray.length > 0) {
          sanitizedObject[key] = sanitizedArray;
        }
      } else if (value !== null && value !== undefined && value !== "") {
        // Include valid scalar values
        sanitizedObject[key] = value;
      }
    });

    return sanitizedObject;
  };

  const handleSubmit = async () => {
    const emptyRoomIndex = formData.details.findIndex(
      (detail) => detail?.room === undefined || detail?.room === null
    );

    if (
      window.location.pathname !== "/services/image-enhancement-form" &&
      window.location.pathname !== "/services/object-removal-form" &&
      window.location.pathname !== "/services/occupied-vacant-form" &&
      window.location.pathname !== "/services/floor-plan-form"
    ) {
      if (emptyRoomIndex !== -1) {
        message.error(
          `Please select a Room/Area for image #${emptyRoomIndex + 1}`
        );
        return;
      }
    }

    const emptyRenovationPriceIndex = formData.details.findIndex(
      (detail) => detail?.renovation_price.length === 0
    );

    console.log(formData.details);

    if (
      emptyRenovationPriceIndex !== -1 &&
      window.location.pathname === "/services/virtual-renovation-form"
    ) {
      message.error(
        `Select at least one renovation option for image #${
          emptyRenovationPriceIndex + 1
        }`
      );
      return;
    }

    if (!agreeTerms) {
      message.error("Please agree to the terms and conditions");
      return;
    }

    if (formData.selectedStyle === "" && !showDesignCard) {
      message.error("Please select a furnishing style for this order.");
      return;
    }

    setIsDisable(true);

    const form_url = window.location.pathname.replace(/\/edit/g, "");
    // let l_sum = sum;
    // let l_totalPrice = totalPrice;
    // let l_discountPrice: number = couponInfo?.discount;
    // let symbol = currSym;
    // first try block is to convert back anything to USD.
    try {
      // l_sum = await convertToUSD(sum, true);
      // l_totalPrice = await convertToUSD(totalPrice, true);
      // l_discountPrice = await convertToUSD(couponInfo?.discount || 0, true);
      // second try block is to hit the api to place the order or update the order.
      try {
        const payload = {
          user_details: {
            email: formData.email || orderData?.email,
            phone: formData.phone || orderData?.phone,
            name: formData.name || orderData?.name,
            team_id: "",
          },
          property_data: {
            order_name: props?.form_name || urlKey,
            order_type: "pr",
            final_amount: couponInfo?.discount
              ? sum + totalPrice - couponInfo?.discount
              : sum + totalPrice,
            order_ammount: sum + totalPrice,
            coupon_code: appliedCoupon || "N/A",
            form_url: form_url,
            price_key: urlKey,
            furnishing_style: formData.selectedStyle,
            images: formData.fileList.map((file, index) => ({
              url: file.url || file.response?.file_url, // Ensure the URL is set correctly
              room_id: formData.details[index]?.room || null,
              image_id: file.uid,
              additional_room_items:
                formData.details[index]?.additionalItems || "",
              room_item_id: formData.details[index]?.items || [],
              additional_services:
                formData.details[index]?.addtional_services || [],
              service_id: formData.details[index]?.exrtraAdditionID || [],
              description: formData.descriptions[index] || "",
              virtual_staging_text:
                formData.details[index]?.virtualStagingText || "",
              story_level: formData.details[index]?.selectedLikeIn?.level || "",
              template_orientation:
                formData.details[index]?.selectedLikeIn?.template_or || "",
              like_in:
                formData.details[index]?.selectedLikeIn?.floorplan.length > 0
                  ? formData.details[index]?.selectedLikeIn?.floorplan
                  : formData.details[index]?.selectedDayToDusk?.effects,
              sky_replacement:
                formData.details[index]?.selectedDayToDusk?.sky_replacement ||
                "",
            })),
          },
        };
        const roomService = formData.fileList.findIndex(
          (file, index) =>
            !payload?.property_data.images[index]?.service_id?.length
        );

        if (window.location.pathname === "/services/virtual-renovation-form") {
          if (roomService !== -1) {
            // If a missing room_id is found, show an error message
            message.error(
              `Atleaset Select one Renovation service for Image number #${
                roomService + 1
              }`
            );
            return; // Exit the function early
          }
        }

        const resp = await apiRequest({
          url: orderData?.order_id
            ? `OrderUpdate/${orderData?.order_id}`
            : "OrderCreate",
          method: orderData?.order_id ? "PUT" : "POST",
          payload: sanitizePayload(payload),
          showMessage: false,
          Authentication: true,
        });

        setOrderInfo((prev) => {
          const imagesCount = formData?.fileList?.length ?? 0;

          return {
            ...prev,
            orderId: resp?.data?.OrderId,
            totalPrice: sum + totalPrice * imagesCount,
            // symbol: symbol,
          };
        });

        if (resp?.data.status === 200) {
          message.success(resp?.data?.message.toUpperCase());
          setCreateResp(resp?.data);
          isChanges();
          setPaymentModalSwitch((prev: boolean) => {
            return !prev;
          });
        } else {
          message.error("Failed to create order. Please try again.");
        }
      } catch (e) {
        console.error("Error ->", e);
      }
    } catch (error) {
      console.error("ERROR Order isn't created correctly!!! ", error);
    } finally {
      setIsDisable(false);
    }
  };
  const handleDetailsChange =
    (index: number) =>
    (details: {
      room: string | undefined;
      items: string[];
      services: string[];
      additionalItems: string;
      exrtraAdditionID: number[];
      virtualStagingText?: string;
      addtional_services?: number[];
      renovation_price?: number[];
      exrtraAdditionChecks?: any;
      selectedLikeIn?: any[];
      selectedDayToDusk?: any[];
    }) => {
      console.log({ details });
      setFormData((prevData) => {
        const newDetails = [...prevData.details];
        newDetails[index] = details;
        const ret_val = {
          ...prevData,
          details: newDetails,
        };
        return ret_val;
      });
    };

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList.map((file: any) => ({
      ...file,
      url: file.response?.url || file.url, // Ensure the URL is captured
    }));
  };

  const handleDesignCardClick = (name: string, images: any) => {
    isChanges();
    setFormData((prevData) => ({
      ...prevData,
      selectedStyle: name,
    }));
  };

  const handleModalImages = (images: any) => {
    isChanges();
    setSliderImages(images);
    setModalVisible(true);
  };

  const handleUploadMedia = async (file: any) => {
    isChanges();
    try {
      const formData = new FormData();
      formData.append("file", file);

      return await fetch(`${process.env.REACT_APP_API_URL}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`, // Adjust the token retrieval as needed
        },
        body: formData,
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error("Error uploading file:", error);
        });
    } catch (e) {
      console.error("Error uploading media:", e);
    }
  };

  const isCommercialForm = () => {
    if (
      window.location.pathname ===
        "/services/commercial/commercial-staging-form" ||
      window.location.pathname ===
        "/edit/services/commercial/commercial-staging-form" ||
      window.location.pathname ===
        "/services/commercial/commercial-renovation-form" ||
      window.location.pathname ===
        "/edit/services/commercial/commercial-renovation-form"
    ) {
      return threeDesignCard;
    }
    return designCardsData;
  };
  const sum = addtionalInfo?.reduce((pv, cv: any) => pv + cv.value, 0);

  const getAggregatedServices = (services: any[]) => {
    const serviceMap: Record<
      string,
      { count: number; total: number; parent_service_name: string }
    > = {};

    services.forEach((service) => {
      const name = service?.only_name;
      const price = Number(service?.value);
      const parent_service_name = service?.parent_service_name;

      if (!name || isNaN(price)) return;

      if (serviceMap[name]) {
        serviceMap[name].count += 1;
        serviceMap[name].total += price;
      } else {
        serviceMap[name] = {
          count: 1,
          total: price,
          parent_service_name,
        };
      }
    });

    return Object.entries(serviceMap)
      .filter(([name]) => {
        // exclude if any service with same name has hide: true
        return !services.some(
          (service) => service?.only_name === name && service?.hide === true
        );
      })
      .map(([name, data]) => ({
        name,
        count: data.count,
        total: Number(data.total.toFixed(2)), // keep number (better for math)
        parent_service_name: data.parent_service_name,
      }));
  };

  function getFilteredArray(data1: any[], data2: any[]) {
    // Extract all the IDs from data1 into a Set for faster lookup
    const idsToRemove = new Set(data1.map((item: any) => item.id));
    // Filter out objects in data2 whose id is found in the idsToRemove Set
    return data2.filter((item: any) => !idsToRemove.has(item.id));
  }

  function getExtraServices(data: any) {
    setExtraAdditionService((prev: any) => [...prev, data]);
  }

  const calculateRenovationPrice = (data: any) => {
    console.log("calculateRenovationPrice", data);
    return data?.reduce((total: any, item: any) => {
      const renovationSum =
        item?.renovation_price?.reduce(
          (sum: any, price: any) => sum + price,
          0
        ) || 0;
      return total + renovationSum;
    }, 0);
  };

  const calculateAdditionalPrice = (data: any) => {
    return data?.reduce((total: number, item: any) => {
      const additionalSum =
        item?.additional_services?.reduce(
          (sum: number, service: any) => sum + (service.price || 0),
          0
        ) || 0;
      return total + additionalSum;
    }, 0);
  };

  function doesPathnameMatch(pathnames: string[]): boolean {
    const currentPath = window.location.pathname; // Get the current pathname
    return pathnames.some((pathname) => currentPath.includes(pathname)); // Check if any pathname matches
  }

  const getAdditionalKeyword = () => {
    let additionalKeyword = "";

    if (
      window.location.pathname === "/services/floor-plan-form" ||
      window.location.pathname === "/edit/services/floor-plan-form"
    ) {
      additionalKeyword = "?floorplan=true";
    } else if (
      window.location.pathname === "/services/virtual-renovation-form" ||
      window.location.pathname === "/edit/services/virtual-renovation-form"
    ) {
      additionalKeyword = "?virtual_renovation=true";
    } else if (
      window.location.pathname === "/services/virtual-staging-form" ||
      window.location.pathname === "/edit/services/virtual-staging-form"
    ) {
      additionalKeyword = "?virtual_staging=true";
    } else if (
      window.location.pathname ===
        "/services/commercial/commercial-staging-form" ||
      window.location.pathname ===
        "/edit/services/commercial/commercial-staging-form"
    ) {
      additionalKeyword = "?virtual_staging=true";
    } else if (
      window.location.pathname ===
        "/services/commercial/commercial-renovation-form" ||
      window.location.pathname ===
        "/edit/services/commercial/commercial-renovation-form"
    ) {
      additionalKeyword = "?virtual_renovation=true";
    }

    if (additionalKeyword.length > 0) {
      setAddtionalKeyword(String(additionalKeyword));
    }
  };

  useEffect(() => {
    getAdditionalKeyword();

    const pathnamesToCheck = [
      "/services/floor-plan-form",
      "/edit/services/floor-plan-form",
      "/services/day-to-dusk-form",
      "/edit/services/day-to-dusk-form",
      "/services/object-removal-form",
      "/edit/services/object-removal-form",
      "/services/business-card-form",
      "/edit/services/business-card-form",
      "/services/vector-design-form",
      "/edit/services/vector-design-form",
      "/services/digital-display-form",
      "/edit/services/digital-display-form",
      "/services/image-enhancement-form",
      "/edit/services/image-enhancement-form",
      "/services/occupied-vacant-form",
      "/edit/services/occupied-vacant-form",
    ];
    setShowDesignCard(doesPathnameMatch(pathnamesToCheck));
  }, [window.location.pathname]);

  useEffect(() => {
    getASservices();
  }, [addtionalKeyword]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const key = queryParams.get("oid");
    if (key) setOrderId(key);
  }, []);

  useEffect(() => {
    if (orderId) fetchOrderDetails();
  }, [orderId]);

  const fetchOrderDetails = async () => {
    try {
      const respondedData = await apiRequest({
        url: `order-details?order_id=${orderId}`,
        method: "GET",
        showMessage: false,
        Authentication: true,
      });
      const resp = await respondedData;

      if (resp?.data) {
        const userInfo = {
          email: resp?.data?.reciever_details.email,
          name: resp?.data?.reciever_details.name,
          phone: resp?.data?.reciever_details.phone,
        };

        let images = [];
        // const contryFrmLcl =
        //   JSON.parse(localStorage.getItem("userLocation") || "{}")?.country ||
        //   null;
        // for (let i = 0; i < resp?.data?.images.length; i++) {
        //   const service = resp?.data?.images[i].additional_services;
        //   // const serviceList = [];
        //   // for (let j = 0; j < service.length; j++) {
        //   //   let cnvrtdSrvcPrc;
        //   //   if (contryFrmLcl) {
        //   //     cnvrtdSrvcPrc = await converterFunc(
        //   //       service[j].price,
        //   //       true,
        //   //       JSON.parse(localStorage.getItem("userLocation") || "{}")
        //   //         ?.country,
        //   //       "USD"
        //   //     );
        //   //   }
        //   //   const data = {
        //   //     id: service[j].id,
        //   //     name: service[j].name,
        //   //     price: contryFrmLcl ? cnvrtdSrvcPrc : service[j].price,
        //   //   };
        //   //   serviceList.push(data);
        //   // }
        //   const cnvrtdSrvcList = {
        //     additional_services: service,
        //     image_id: resp?.data?.images[i].image_id,
        //     image_number: resp?.data?.images[i].image_number,
        //     room_area: resp?.data?.images[i].room_area,
        //     selected_room_items: resp?.data?.images[i].selected_room_items,
        //     selected_service_items:
        //       resp?.data?.images[i].selected_service_items,
        //     url: resp?.data?.images[i].url,
        //     virtual_staging_text: resp?.data?.images[i].virtual_staging_text,
        //   };
        //   images.push(cnvrtdSrvcList);
        // }
        // resp.data.images = images;
        const formData = {
          ...userInfo,
          ...resp?.data,
        };

        setOrderData({
          ...resp.data,
          ...userInfo,
          ...formData,
        });
        setSkyID(resp?.data?.images?.map((img: any) => img?.sky_replacement));

        setFormData((prev) => ({
          ...prev,
          fileList: resp?.data?.images?.map((image: any) => ({
            uid: image.image_id,
            url: image.url,
            response: { file_url: image.url },
          })),
          descriptions: resp?.data?.images?.map(
            (image: any) => image.additional_room_items
          ),
        }));

        form.setFieldsValue(formData);
      }
    } catch (error) {
      console.error("Failed to fetch order details", error);
    }
  };
  useEffect(() => {
    if (orderData?.furnishing_style) {
      setFormData((prevData) => ({
        ...prevData,
        selectedStyle: orderData?.furnishing_style,
      }));
    }
  }, [orderData]);

  const editImageData = useMemo(() => orderData?.images || [], [orderData]);

  const handleDeleteFile = (file: any) => {
    // Step 1: Remove the object that matches the image_id
    const updatedImages = formData?.fileList?.filter(
      (item: any) => item.uid !== file
    );
    const filterimg = orderData?.images?.filter(
      (item: any) => item.image_id !== file
    );

    // Step 2: Get the original indices of the remaining images in the original orderData.images array
    const imageIndices = filterimg?.map((item: any) => ({
      image_id: item.image_id,
      originalIndex: orderData?.images.findIndex(
        (img: any) => img.image_id === item.image_id
      ),
    }));

    const sasuke = filterimg?.filter((img) =>
      updatedImages?.some((updatedImg) => updatedImg.uid === img.image_id)
    );
    // Step 3: Map additional_services while preserving the original image index
    const updatedAdditionalInfo = sasuke?.flatMap((image: any) => {
      // Find the original index of this image_id in the original orderData.images array
      const originalIndex =
        imageIndices?.find((item: any) => item.image_id === image.image_id)
          ?.originalIndex ?? -1;

      return image?.additional_services?.map((service: any) => ({
        checked: true,
        name: `${service.name} - ${service.price} $`,
        value: service.price,
        key: service.id,
        id: `${image.image_id}-${originalIndex}-${service.id}`, // Append the original index
        hide: false,
        only_name: service.name,
      }));
    });

    // Step 4: Set the updatedAdditionalInfo into additionalInfo
    if (updatedAdditionalInfo) setAddtionalInfo(updatedAdditionalInfo);
  };

  const extraAdditionalService = async () => {
    // services-by-parent?parent_service_name=Commercial_Renovation
    // services-by-parent?parent_service_name=Residential_Virtual_Renovation
    // get-name-types/?name=floorplan
    // get-name-types/?name=Day_to_Dusk
    let url =
      "services-by-parent?parent_service_name=Residential_Virtual_Renovation";

    if (
      window.location.pathname ===
        "/services/commercial/commercial-renovation-form" ||
      window.location.pathname ===
        "/edit/services/commercial/commercial-renovation-form"
    ) {
      url = "services-by-parent?parent_service_name=Commercial_Renovation";
    }

    const resp = await apiRequest({
      url: url,
      method: "GET",
      payload: {},
      showMessage: false,
      Authentication: false,
    });

    if (resp?.status === 200) {
      const data = resp?.data;
      setExtraAddition(data);
      // setInitCountry("United States");
      // if (makePaymentButtonAmountAutoConverted) {
      //   setCurrSym(data[0].currency_symbol);
      // } else {
      //   setCurrSym("$");
      // }
    }
  };

  useEffect(() => {
    extraAdditionalService();
  }, []);

  const onFinishFailed = ({ errorFields }: any) => {
    if (errorFields.length > 0) {
      window.scrollTo(0, refVar.current.getBoundingClientRect().y);
      message.error("Please fill all required fields!");
    }
  };

  const handleAfterCreate = () => {
    if (createResp?.form_url && createResp?.price_key && createResp.OrderId)
      window.open(
        `/edit${createResp?.form_url}?key=${createResp?.price_key}&oid=${createResp.OrderId}`,
        "_self"
      );
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      event.returnValue =
        "If you refresh or go back, you will lose your filled data.";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleCoupanList = async () => {
    try {
      const resp = await apiRequest({
        url: "get-coupons/",
        method: "GET",
        payload: {},
        showMessage: false,
        Authentication: false,
      });

      if (resp?.data?.length > 0) {
        setCouponList(resp?.data);
      }
    } catch {
      console.error("Error fetching coupon list");
    }
  };

  useEffect(() => {
    handleCoupanList();
  }, []);

  useEffect(() => {
    if (appliedCoupon) {
      handleCoupon(appliedCoupon);
    } else if (sum + totalPrice === 0) {
      // removeCoupon()
      setAppliedCoupon(null);
      setCouponInfo({});
    }
  }, [sum, totalPrice]);

  const handleCoupon = async (code: string) => {
    if (sum + totalPrice === 0) {
      message.error("Please select at least one image to apply coupon.");
      return;
    }

    const decodetoken: any = localStorage.getItem("accessToken");
    const decoded: any = jwtDecode(decodetoken);

    let obj: any = {
      coupon_name: code,
      service_name: urlKey,
      total_amount: sum + totalPrice,
      user_id: decoded?.user_id,
    };

    try {
      const resp = await apiRequest({
        url: "apply-coupon/",
        method: "POST",
        payload: obj,
        showMessage: false,
        Authentication: false,
      });

      if (!resp?.data?.is_valid) {
        message.error(resp?.data?.reason);
        setAppliedCoupon(null);
      } else {
        message.success("Coupon applied successfully");
        setAppliedCoupon(code);
        setCouponInfo(resp?.data);
      }

      if (!resp?.data) {
        message.error("Failed to apply coupon");
      }
    } catch (error) {
      console.error("Error applying coupon", error);
      message.error("Something went wrong!! Failed to apply coupon");
    }
  };

  const removeCoupon = () => {
    setAppliedCoupon(null);
    setCouponInfo(null);
    message.destroy();
    message.info("Coupon removed.");
    setCouponInfo({});
    // Optionally, make an API call to "remove" or reset the coupon on backend too
  };

  // interface CurrencyInfo {
  //   country: string;
  //   currency_code: string;
  //   symbol: string;
  //   converted_amount: number;
  //   exchange_rate: number;
  // }

  // interface LocationData {
  //   latitude: number;
  //   longitude: number;
  //   accuracy: number;
  //   country: string;
  //   timestamp: number;
  //   currency: CurrencyInfo;
  // }

  // function getCurrencySymbol(key: string = "userLocation"): string {
  //   try {
  //     const raw = localStorage.getItem(key);
  //     if (!raw) return "$";

  //     const data: LocationData = JSON.parse(raw);

  //     return data?.currency?.symbol ?? "$";
  //   } catch (err) {
  //     console.error("Failed to extract currency symbol:", err);
  //     return "$";
  //   }
  // }

  // const convertFinalPrice = async ({
  //   sum,
  //   totalPrice,
  //   couponInfo,
  // }: ConvertFinalPriceArgs) => {
  //   try {
  //     console.log({ sum, totalPrice });
  //     const finalPrice = sum + totalPrice - (couponInfo?.discount ?? 0);

  //     const raw: any = localStorage.getItem("userLocation");
  //     const data: LocationData = JSON.parse(raw);
  //     const baseCurrency = data?.currency?.currency_code ?? "USD";
  //     const country = "United States";

  //     const response = await apiRequest({
  //       url: "/convert-local-currency/",
  //       method: "POST",
  //       payload: {
  //         base_currency: baseCurrency,
  //         country,
  //         price: finalPrice,
  //       },
  //       showMessage: false,
  //     });

  //     if (response.status === 200) {
  //       return response.data;
  //     }

  //     return null;
  //   } catch (error) {
  //     console.error("Error converting currency:", error);
  //     return null;
  //   }
  // };

  // const convertToUSD = async (
  //   toConvertPrice: number,
  //   onlyMoney = false,
  //   country = "United States",
  //   base_currency?: string
  // ) => {
  //   try {
  //     const raw: any = localStorage.getItem("userLocation");
  //     const data: LocationData = JSON.parse(raw);
  //     const response = await apiRequest({
  //       url: "/convert-local-currency/",
  //       method: "POST",
  //       payload: {
  //         base_currency:
  //           base_currency || data?.currency?.currency_code || "USD",
  //         country: country,
  //         price: toConvertPrice,
  //       },
  //     });

  //     if (response.status === 200) {
  //       const data = response.data;
  //       if (onlyMoney) {
  //         return data?.converted_amount;
  //       } else {
  //         return [data?.converted_amount, data?.symbol];
  //       }
  //     }
  //     return [];
  //   } catch (error) {
  //     console.error("Conversion Error!!! ", error);
  //     return [];
  //   }
  // };

  // const handlePriceConversion = async () => {
  //   // const converted = await convertFinalPrice({
  //   //   sum,
  //   //   totalPrice,
  //   //   couponInfo,
  //   // });
  //   let converted = sum + totalPrice - (couponInfo?.discount ?? 0);
  //   if (!makePaymentButtonAmountAutoConverted) {
  //     converted = await convertToUSD(converted, true);
  //   }
  //   if (formData.fileList.length === 0) {
  //     setLastConvertedPrice(null);
  //     return;
  //   } else {
  //     setLastConvertedPrice(converted || null);
  //   }
  // };
  // const changeLocalToCurrency = async () => {
  //   if (window.location.pathname.includes("edit")) {
  //     const convertSum = await convertToUSD(sum, true, "India", "USD");

  //     const convertedTotal =
  //       convertSum + totalPrice - (couponInfo?.discount || 0);
  //     setLocalCurrChanging(convertedTotal);
  //   }
  // };
  // useEffect(() => {
  //   handlePriceConversion();
  //   // changeLocalToCurrency();
  // }, [sum, totalPrice, couponInfo]);

  // console.log("orderData", orderData);

  return (
    <>
      <div className="steps-container form">
        <StepComponent current={current} steps={steps} />
      </div>
      <div className="order-form-container hp-container">
        <h2 ref={refVar} className="mb-4 pt-4">
          Start by telling us about yourself
        </h2>
        <Form
          layout="vertical"
          onFinish={() => {
            handleSubmit();
          }}
          form={form}
          initialValues={orderData ?? {}}
          onFinishFailed={onFinishFailed}
        >
          <Row gutter={10} className="basicDetails">
            <Col sm={24} md={24} lg={12} xl={12}>
              <Item
                label="Your name"
                name="name"
                rules={[{ required: true, message: "Please enter your name." }]}
              >
                <Input
                  placeholder="For example; John Smith"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </Item>
            </Col>

            <Col sm={24} md={24} lg={12} xl={12}>
              <Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please input your Email." },
                  {
                    type: "email",
                    message: "The input is not a valid E-mail.",
                  },
                ]}
              >
                <Input
                  type="email"
                  placeholder="For example; johnsmith98@gmail.com"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </Item>
            </Col>

            <Col sm={24} md={24} lg={12} xl={12}>
              <Item
                label="Phone number"
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "Please enter your phone number.",
                  },
                ]}
              >
                <PhoneInput
                  country={"in"}
                  value={formData.phone}
                  enableLongNumbers
                  onChange={handlePhoneChange}
                  inputStyle={{ width: "100%" }}
                />
              </Item>
            </Col>
          </Row>

          {!showDesignCard ? (
            <>
              <hr />
              <h5>Pick a furnishing style for your property*</h5>
              <div className="row pt-4">
                {isCommercialForm()?.map((design, index) => (
                  <div
                    className={`col-6 col-md-2 col-sm-4 ${
                      design.name === formData.selectedStyle && "selected-style"
                    }`}
                    key={index}
                  >
                    <div
                      className={`design-card text-center p-2 ${
                        formData.selectedStyle === design.name ? "selected" : ""
                      }`}
                      onClick={() =>
                        handleDesignCardClick(design.name, design.images)
                      }
                    >
                      <div className="design-image">
                        <img
                          src={design.thumbnail}
                          alt="Design Visual"
                          className="w-100"
                        />
                      </div>
                      <div className="design-text">
                        <span>{design.name}</span>
                      </div>
                      <div
                        className="see-examplebtn"
                        style={{
                          color: "navy",
                          cursor: "pointer",
                          fontSize: "12px",
                        }}
                        onClick={() => handleModalImages(design.images)}
                      >
                        view example
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            ""
          )}

          <hr />
          <Item
            label="Upload some photos here*"
            name="upload"
            getValueFromEvent={normFile}
            rules={[
              {
                required: formData?.fileList?.length > 0 ? false : true,
                message: "Please upload some photos.",
              },
            ]}
          >
            <Upload
              listType="picture"
              beforeUpload={(file) => {
                const isImage = file.type.startsWith("image/");
                if (!isImage) {
                  message.error("Please Upload Only Image files.");
                }
                return isImage || Upload.LIST_IGNORE;
              }}
              fileList={formData.fileList}
              accept="image/*"
              onChange={handleUploadChange}
              // beforeUpload={() => false} // Prevent automatic upload
              multiple
              customRequest={({ file, onSuccess, onError }) => {
                handleUploadMedia(file).then(onSuccess).catch(onError);
              }}
              onRemove={(file) => handleDeleteFile(file?.uid)}
            >
              <Button icon={<UploadOutlined />}>Upload More Photos</Button>
            </Upload>
          </Item>

          {formData?.fileList.length > 0 && (
            <>
              <hr />

              <b>Add Details about your photos.</b>

              <div className="image-detail pt-4">
                {formData?.fileList.map((file, index) => {
                  // const uid = file.uid;
                  const oindex: any = orderData?.images.findIndex(
                    (img: any) => img.image_id === file?.uid
                  );
                  const editData = editImageData[index];
                  console.log({ editData });
                  console.log({ editImageData });

                  const adws = editData?.additional_services?.map((item) => ({
                    ...item, // Spread the original object
                    image_id: editData?.image_id, // Add image_id property
                  }));

                  return (
                    <PhotoDetails
                      itemsSelector={
                        window.location.pathname.includes("commercial")
                          ? false
                          : true
                      }
                      asInfo={asInfo || []}
                      roomInfo={roomResp}
                      key={file.uid}
                      imageSrc={file?.response?.file_url}
                      onClose={handleClose(index)}
                      moreDetail={showDesignCard ? false : true}
                      onDetailsChange={handleDetailsChange(index)}
                      onDescriptionChange={handleDescriptionChange(index)}
                      description={
                        formData.descriptions[index] ||
                        orderData?.images[index]?.additional_room_items ||
                        ""
                      }
                      setAddtionalInfo={setAddtionalInfo}
                      cardNumber={file?.uid}
                      setujjwal={yogendraFunc}
                      getExtraServices={getExtraServices}
                      selected_renovation={extraAdditionService}
                      setRenovation={setExtraAdditionService}
                      handleSkychange={handleSkychange}
                      delFunc={delFunc}
                      skyID={skyID}
                      extraAddition={extraEddition}
                      editData={orderData}
                      editDuskEff={editData?.like_in}
                      edit_discription={editData?.additional_room_items}
                      edit_sky={editData?.sky_replacement}
                      edit_temp={editData?.template_orientation}
                      edit_story={editData?.story_level}
                      edit_room_area={editData?.room_area}
                      edit_selected_room_items={editData?.selected_room_items}
                      edit_selected_renovation={
                        editData?.selected_service_items
                      }
                      edit_virtual_staging_text={editData?.virtual_staging_text}
                      edit_additional_services={adws}
                      oindex={oindex}
                    />
                  );
                })}
              </div>
            </>
          )}

          <hr />
          <div className="paymentBox">
            <div className="payment-coupan-box">
              <div
                className="coupon-container"
                // style={{ visibility: "hidden", opacity: 0 }}
              >
                <label htmlFor="coupon" className="coupon-label">
                  Enter a coupon code -{" "}
                  <span
                    onClick={() => setCouponBox(true)}
                    style={{ color: "blue", cursor: "pointer" }}
                  >
                    <u>see all coupons</u>
                  </span>
                </label>
                <div className="coupon-input-container">
                  <input
                    id="coupon"
                    className="coupon-input"
                    value={
                      appliedCoupon && sum + totalPrice !== 0
                        ? appliedCoupon
                        : ""
                    }
                    placeholder="Ex. HURRY100"
                    onClick={() => setCouponBox(true)}
                  />
                  {appliedCoupon && sum + totalPrice !== 0 ? (
                    <button
                      title="Remove Coupon"
                      className="remove-coupon"
                      onClick={() => {
                        removeCoupon();
                        setAppliedCoupon(null);
                        setCouponInfo(null);
                      }}
                    >
                      X
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    disabled={appliedCoupon ? true : false}
                    className="apply-button"
                  >
                    {appliedCoupon ? "Applied" : "APPLY"}
                  </button>
                </div>
              </div>

              <div className="mt-5">
                <div className="terms-and-makePayment mt-4">
                  <Checkbox required onChange={onCheckboxChange}>
                    I agree to{" "}
                    <span
                      onClick={() => setTermsModalVisible(!termsModalVisible)}
                      style={{ color: "blue", cursor: "pointer" }}
                    >
                      Terms & Conditions*
                    </span>
                  </Checkbox>
                </div>
                <button
                  style={{ filter: isDisable ? "invert(1)" : "none" }}
                  disabled={isDisable}
                  type="submit"
                  className="theme-btn mt-3"
                >
                  <Flex gap={10}>
                    {/* <div>
                      {lastConvertedPrice
                        ? (
                          <>
                            Make Payment - <ConvertedPrice price={lastConvertedPrice} />
                          </>
                        )
                        : "Make Payment"}
                    </div> */}
                    <div>
                      {couponInfo && couponInfo?.discount
                        ? `Make Payment - $${
                            sum + totalPrice - couponInfo?.discount
                          }`
                        : `Make Payment - $${sum + totalPrice}`}
                    </div>
                    <div>
                      <ArrowRightOutlined className="right_icon" />
                    </div>
                  </Flex>
                </button>
              </div>
            </div>

            <div className="order-summary-container">
              <div className="order-summary">
                <h2>ORDER SUMMARY</h2>
                <div className="order-item w-100">
                  {formData?.fileList?.length > 0 ? (
                    <span className="w-100">
                      {/* {addtionalInfo?.length > 0 && <b>Additional Services</b>} */}

                      {/* {addtionalInfo?.length > 0 && (
                        <hr style={{ marginBlock: "5px" }} />
                      )} */}
                      {addtionalInfo?.length > 0 &&
                        getAggregatedServices(addtionalInfo)?.map((service) => {
                          return (
                            <div
                              className="d-flex justify-content-between"
                              key={service.name}
                            >
                              <span>
                                {service?.name} for {service?.count}{" "}
                                {service.count === 1 ? "image" : "images"}
                              </span>
                              <b>
                                {/* {getCurrencySymbol()} */}
                                <ConvertedPrice
                                  price={Number(service?.total)}
                                />
                              </b>
                            </div>
                          );
                        })}
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                {window.location.pathname ===
                  "/services/virtual-renovation-form" ||
                window.location.pathname ===
                  "/edit/services/commercial/commercial-renovation-form" ||
                window.location.pathname ===
                  "/services/commercial/commercial-renovation-form" ||
                window.location.pathname ===
                  "/edit/services/virtual-renovation-form" ? (
                  <>
                    <Flex justify="space-between">
                      <span>
                        Price of {urlKey.replace(/_/g, " ").split(" ")[1]}{" "}
                        {urlKey.replace(/_/g, " ").split(" ")[2]} service for{" "}
                        {formData?.fileList.length}{" "}
                        {formData?.fileList.length === 1 ? "Image" : "Images"}{" "}
                      </span>
                      <b>
                        {/* {getCurrencySymbol()} */}
                        <ConvertedPrice
                          price={calculateRenovationPrice(formData?.details)}
                        />
                      </b>
                    </Flex>
                  </>
                ) : (
                  <>
                    <Flex justify="space-between">
                      <span>
                        Price of{" "}
                        {window.location.pathname ===
                        "/services/occupied-vacant-form" ? (
                          "Occupied to vacant "
                        ) : (
                          <>
                            {urlKey?.replace(/_/g, " ").split(" ")[1]}{" "}
                            {urlKey?.replace(/_/g, " ").split(" ")[2]}{" "}
                          </>
                        )}
                        service for {formData?.fileList.length}{" "}
                        {formData?.fileList.length === 1 ? "Image" : "Images"}{" "}
                      </span>
                      <b>
                        {/* {getCurrencySymbol()} */}
                        <ConvertedPrice price={Number(totalPrice.toFixed(2))} />
                      </b>
                    </Flex>
                  </>
                )}
                {appliedCoupon && sum + totalPrice !== 0 && (
                  <>
                    <hr />
                    <div className="d-flex justify-content-between">
                      <span className="applied-coupon">
                        Coupon Applied: {appliedCoupon}
                      </span>

                      {couponInfo?.discount && (
                        <span className="coupon_amt">
                          - <ConvertedPrice price={couponInfo?.discount} />
                        </span>
                      )}
                    </div>
                  </>
                )}
                <hr />
                <div className="order-total mt-0">
                  <span>ORDER TOTAL</span>
                  {appliedCoupon ? (
                    <span>
                      {formData?.fileList.length > 0 ? (
                        <ConvertedPrice
                          price={sum + totalPrice - couponInfo?.discount}
                        />
                      ) : (
                        "0.00"
                      )}
                    </span>
                  ) : (
                    <span>
                      {formData?.fileList.length > 0 ? (
                        <ConvertedPrice price={sum + totalPrice} />
                      ) : (
                        "0.00"
                      )}
                    </span>
                  )}
                </div>
              </div>
              <div className="payment-secured">
                <span>PAYMENTS SECURED BY</span>
                <div className="payment-icons">
                  <img
                    referrerPolicy="origin"
                    src="https://badges.razorpay.com/badge-dark.png "
                    alt="Razorpay | Payment Gateway | Neobank"
                  />
                  <img
                    src="https://w7.pngwing.com/pngs/32/363/png-transparent-visa-master-card-and-american-express-mastercard-payment-visa-credit-card-emv-credit-card-visa-and-master-card-background-text-display-advertising-logo.png"
                    alt="Cards are accepted"
                  />
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <Modal
        centered
        width="810px"
        onCancel={() => {
          setPaymentModalSwitch(false);
          handleAfterCreate();
        }}
        footer={false}
        open={paymentModalSwitch}
        className="payment-modal"
      >
        <Paypal
          final_amount={
            couponInfo?.discount
              ? sum + totalPrice - couponInfo?.discount
              : sum + totalPrice
          }
          details={formData}
          info={orderInfo}
        />
      </Modal>

      <Modal
        title="Design Gallery"
        width="800px"
        open={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
      >
        <GallerySlider images={sliderImages} />
      </Modal>

      <Modal
        centered
        width="810px"
        onCancel={() => setTermsModalVisible(false)}
        footer={false}
        open={termsModalVisible}
        className="terms-modal"
      >
        <TermsCon />
      </Modal>

      <Modal
        centered
        width="710px"
        className="coupon-modal"
        onCancel={() => setCouponBox(false)}
        footer={false}
        title={<h4 className="mb-4">Available Coupons</h4>}
        open={couponBox}
      >
        <div className="coupan-list">
          {couponList?.length > 0 ? (
            couponList.map((item: any) => (
              <div className="coupan-item flex-mobile-wrap" key={item.id}>
                <div className="w-100">
                  <p className="m-0 coup_date_title">
                    <b>{item.coupon_name}</b>
                    <span>
                      {item?.coupon_end_date
                        ? `valid till: ${formatDate(
                            item.coupon_end_date,
                            "DD-MM-YYYY"
                          )}`
                        : "No Expiry"}
                    </span>
                  </p>
                  {/* <span className="coupon_desc">{item.offer_terms}</span> */}
                  <p
                    className="coupon_desc"
                    dangerouslySetInnerHTML={{ __html: item.offer_terms }}
                  ></p>
                  <p
                    className="coupon_terms"
                    dangerouslySetInnerHTML={{ __html: item.terms }}
                  ></p>
                  {/* <p className="coupon_terms">{item.terms}</p> */}
                </div>
                <div style={{ maxWidth: "110px", width: "100%" }}>
                  {appliedCoupon === item.coupon_name ? (
                    <div
                      className="d-flex align-items-center justify-content-between"
                      style={{
                        maxWidth: "100px",
                        width: "100%",
                        padding: "2px 4px",
                      }}
                    >
                      <span
                        style={{
                          color: "green",
                          fontWeight: "bold",
                          marginRight: "8px",
                        }}
                      >
                        Applied
                      </span>
                      <button
                        onClick={removeCoupon}
                        style={{
                          marginLeft: "5px",
                          padding: "0",
                          border: "none",
                          background: "none",
                          cursor: "pointer",
                        }}
                      >
                        <DeleteFilled style={{ color: "red" }} />
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => handleCoupon(item.coupon_name)}
                      className="theme-btn"
                      style={{
                        lineHeight: "1",
                        minWidth: "unset",
                        maxWidth: "120px",
                      }}
                    >
                      Apply
                    </button>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="coupan-item">No coupons available</div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default CommercialStagingForm;
